import React, { Component } from 'react'
import Select from 'react-select'
import apiService from '../../services/apiservices'

class DepartmentTeams extends Component {
    constructor() {
        super()
        this.state = {
            departmentTeamsList: {},
            selectedDepartment:"",
            selectedCity:""
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getDepartmentTeamsComboList()
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }


    componentDidUpdate() {
        if (this.props.selectedDepartment!== this.state.selectedDepartment || this.props.selectedCity!== this.state.selectedCity) {
             let selectedDepartment=this.props.selectedDepartment 
             let selectedCity=this.props.selectedCity 
             this.setState({
                selectedDepartment:selectedDepartment,
                selectedCity:selectedCity
                },() => {
                 this.getDepartmentTeamsComboList()
            });            
        }
    }
    getDepartmentTeamsComboList = () => {
        apiService.getDepartmentTeamsComboList(this.state.selectedDepartment,this.state.selectedCity)
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                     this.setState({
                        departmentTeamsList: listData.data
                    })
                    
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }
    

    render() {
        let list = {}
        list = Object.keys(this.state.departmentTeamsList).map((value,index) => {
            
            return {
                label : this.state.departmentTeamsList[value],
                value : value
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                placeholder="Select Department Team"
                options={list}
                onChange={(e) => { (e) ? this.props.departmentTeamChange(e) : this.props.departmentTeamChange([])}}
                />
            </div>
        )
    }
}
export default DepartmentTeams


// WEBPACK FOOTER //
// ./src/modules/Employees/Components/DropDowns/DepartmentTeams.js